import template from './employee_field_report_help.html'
import * as Utils from '../../../lib/savanna_utils.js'

class EmployeeFieldReportHelpViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{
		this.dialog.close();
	}
}

class EmployeeFieldReportHelpPage
{
	constructor(bindings)
	{
		this.viewModel = new EmployeeFieldReportHelpViewModel(this)
		this.bindings = bindings
	}

	async init()
	{
		Utils.refresh_data_visible_roles()
	}
}

// Register the dialog
export default {
	name: 'EmployeeFieldReportHelp',
	dialog_class: EmployeeFieldReportHelpPage,
	template: template,
	template_filename: 'translation/dialogs/employee_field_report_help',
	provider: 'ps'
}
